// extracted by mini-css-extract-plugin
export default {"social":"social_social__nLbRg","linkedin":"social_linkedin__c3crV","social__title":"social_social__title__YZLAg"};